module.exports = __webpack_public_path__ + "media/images/partners/timeout-60c991ac01f6c84027a69b54258b4ef8.svg";